import { useEffect, useState } from "react";
import { useQuery, gql } from "@apollo/client";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { useAtomValue } from "jotai";

//STATE
import { previewContentAtom } from "../../state/appState";

//GRAPHQL
import { GET_NEWS_HERO } from "../../graphql/news";

const sliderSettings = {
	dots: true,
	arrows: false,
	fade: true,
	infinite: true,
	speed: 1000,
	autoplay: true,
	autoplaySpeed: 30000,
	slidesToShow: 1,
	slidesToScroll: 1,
	className: "heroSlider",
};

const NewsSlider = () => {
	//Local State
	const [newsArticles, setNewsArticles] = useState([]);

	//Atom State
	const isPreviewContent = useAtomValue(previewContentAtom);

	//GraphQL Setup
	const { data, errors, loading } = useQuery(GET_NEWS_HERO, {
		variables: {
			isPreview: isPreviewContent,
			queryLimit: 3,
		},
	});

	useEffect(() => {
		data && data.newsCollection.items.length && setNewsArticles(data.newsCollection.items);
	}, [data]);

	return (
		<Slider {...sliderSettings}>
			{newsArticles.length &&
				newsArticles.map((newsItem, idx) => {
					return (
						<div className="slideWrapper" key={`newsSlider-${idx}`}>
							<Link to={`/news/${newsItem.slug}`} state={{ newsArticleId: newsItem.sys.id }} className="slideWrapper-content">
								<img src={newsItem.heroImage.url} alt={newsItem.heroImage.title} />
								<div className="newsTitle-wrapper fontColour-cream">
									<span className="fontSize-regular">Latest News</span>
									<span className="limitLines-1 fontSize-medium">{newsItem.title}</span>
								</div>
							</Link>
						</div>
					);
				})}
		</Slider>
	);
};

export default NewsSlider;
